import React from 'react'
import Table from 'react-bootstrap/Table';

const Records = ({data}) => {
  return (  
    <Table responsive>
    <thead>
    <tr>
        <th>#</th>
        <th>Nombre</th>
        <th>Apellido</th>
        <th>Email</th>
        <th>Phone</th>
        <th>Mensaje</th>
        <th>Creado</th>
    </tr>
    </thead>
    <tbody>
    {
        data.length > 0 && data.map((msg, index) => 
        <tr key={index}>
            <td>{msg.id}</td>
            <td>{msg.firstname}</td>
            <td>{msg.lastname}</td>
            <td>{msg.email}</td>
            <td>{msg.phone}</td>
            <td>{msg.message}</td>
            <td>{msg.created_at}</td>
        </tr>
        )
    }
    </tbody>
    </Table>
  ) 
}

export default Records  